import type { NextPage } from "next";
import { useRollbarContext } from "@rollbar/react";
import config from "@/libs/config";

import { DataProvisionPolicy } from "@/components/pages/DataProvisionPolicy";

const PolicyDataProvision: NextPage = () => {
  useRollbarContext("terms/policy-data-provision");

  return (
    <DataProvisionPolicy
      bankCode={config.BANK_CODE}
      bankName={config.BANK_NAME}
      bankFormalName={config.BANK_FORMAL_NAME}
      dataProvisionRegulationDate={config.DATA_PROVISION_REGULATION_DATE}
      dataProvisionRevisionDate={config.DATA_PROVISION_REVISION_DATE}
      additionalProviders={config.ADDITIONAL_PROVIDERS}
      isInsuranceAgency={config.IS_INDUSTRY_TYPE_INSURANCE}
    />
  );
};

export default PolicyDataProvision;
